import { Box, styled } from "@mui/material";
import { colors } from "../../theme/colors";

export const LayoutContainer = styled(Box)({
  display: "flex",
  bgcolor: colors.background.default,
});

export const ContentLayout = styled(Box)({
  flex: 1,
  marginLeft: "280px",
  padding: 24,
});

export const GoBackContainer = styled(Box)({
  marginBottom: "24px",
});

export const MainContainer = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background?.secondary || "#FFFFFF",
  borderRadius: "12px",
  padding: "24px",
  boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
}));
